/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import PropTypes from "prop-types";
import InputWithButton from "../BasicInputs/InputWithButton.jsx";
import EntityWrapperSmallLabel from "../EntityDisplay/EntityWrappers/EntityWrapperSmallLabel.jsx";


class PasswordInputComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isHidden: true,
        };
    }

    render() {
        let {value = ""} = this.props
        let {isHidden} = this.state

        return (
            <>
                <EntityWrapperSmallLabel label={this.props.name} isRequired={this.props.isRequired}
                                         helpText={this.props.helpText}>
                    <InputWithButton
                        type={"text"}
                        className={` ${(isHidden && value !== "") && ("textBlur select-none")}`}
                        onClick={() => this.setState((state) => ({isHidden: !state.isHidden}))}
                        value={(isHidden ? "***********" : value)}
                        onFocus={this.props.onFocus}
                        onChange={this.props.onChange}
                        iconName={this.state.isHidden ? ('AiOutlineEye') : ('AiOutlineEyeInvisible')}
                        placeholder={this.props.placeholder}/>
                </EntityWrapperSmallLabel>
            </>)
    };
}

export default PasswordInputComponent;

PasswordInputComponent.propTypes = {
    value: PropTypes.string,
    width: PropTypes.string,

}
PasswordInputComponent.defaultProps = {
    width: 'calc(100% - 110px)',


}
